




































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

@Component({
  components: {}
})
class Input3InputWithUpdateButton extends Vue {

  @Prop({ default: 'INPUT_TYPE_TEXT_FIELD' }) inputType?: string

  @Prop({ default: '' }) initialValue?: any
  @Prop({ default: '' }) selectList?: any[]

  @Prop({ default: '' }) label?: string
  @Prop({ default: false }) outlined?: boolean
  @Prop({ default: false }) disabled?: boolean
  @Prop({ default: () => [] }) rules?: any
  @Prop({ default: '' }) prependIcon?: string
  @Prop({ default: false }) multipleSelect?: boolean
  @Prop({ default: false }) chips?: boolean

  INPUT_TYPE_TEXT_FIELD = 'INPUT_TYPE_TEXT_FIELD'
  INPUT_TYPE_TEXT_AREA = 'INPUT_TYPE_TEXT_AREA'
  INPUT_TYPE_SELECT_INPUT = 'INPUT_TYPE_SELECT_INPUT'

  inputValue: any = ''

  hasErrorInput: boolean = false


  get isInitialValueChanged (): boolean {
    return JSON.stringify(this.initialValue) !== JSON.stringify(this.inputValue)
  }

  @Watch('initialValue') updateInitialValue () {
    if (Array.isArray(this.initialValue)) {
      Vue.set(this, 'inputValue', Object.assign([], this.initialValue) || [])
    } else {
      this.inputValue = this.initialValue
    }
  }

  mounted () {
    if (Array.isArray(this.initialValue)) {
      Vue.set(this, 'inputValue', Object.assign([], this.initialValue) || [])
    } else {
      this.inputValue = this.initialValue
    }
  }

  updateValue () {
    this.$emit('update-value', this.inputValue)
  }

  resetInputValue () {
    if (Array.isArray(this.initialValue)) {
      Vue.set(this, 'inputValue', Object.assign([], this.initialValue) || [])
    } else {
      this.inputValue = this.initialValue
    }
  }

  receiveErrorFromInput (hasErrorInput: any) {
    this.hasErrorInput = hasErrorInput
  }
}

export default Input3InputWithUpdateButton

